export default {
  sessionInitialization: {
    OIDC_AUTH: 'Loading user data',
    STEERING_INITIALIZATION: 'Initializing content management session',
  },

  loginScreen: {
    intro:
      'AURA is radio automation software for the special needs of community radios. AURA has been developed in several Austrian community radios and it is open source.',
  },

  programEntry: {
    scheduled: 'This program slot was scheduled.',
    fallback:
      'This program slot was empty and has automatically been filled with the station’s fallback program.',
    startsAt: 'Starts on %{formattedDate}',
    endsAt: 'Ends on %{formattedDate}',
  },

  showManager: {
    title: 'Radio shows',
    generalSettings: 'General settings for show',
  },

  myShows: {
    title: 'My Shows',
    itemsPerPage: 'Shows per page',
    searchLabel: 'Search by name',
    searchPlaceholder: 'Name of the show...',
    categoryLabel: 'Search by category',
    showCount: 'Showing %{count} of %{total} shows.',
    sortAndFilter: 'Sort and filter shows',
    sortAndFilterShows: 'Sort and filter',
    sort: 'Sort',
    filter: 'Filter',
  },

  showListGrid: {
    otherShows: 'Other Shows',
  },

  profile: {
    singular: 'Profile',
    plural: 'Profiles',
    fields: {
      name: 'Name',
      email: 'Email',
      biography: 'Biography',
      image: 'Image',
      links: 'Links',
      isActive: 'Active',
      ownerIds: 'Assigned user accounts',
    },
    labels: {
      hasAccount: 'Has account',
      createNew: 'Create “%{name}”',
      similarSelected: 'Similar already selected profiles: %{names}',
      hostsOnly: 'Only editors',
      editorOfShows: 'Editor of shows',
      notAssignedAsEditor: 'This profile is not assigned to any show as an editor.',
    },
    editor: {
      deletion: {
        label: 'Delete profile',
        description: 'Removes the profile and all existing relations to shows and episodes.',
        confirm: {
          text: 'The profile will be <strong>irretrievably deleted</strong>. It is not possible to restore it later. Existing relations to shows and episodes will be deleted as well. Are you sure you want to delete the profile <strong>%{profile}</strong>?',
          confirmLabel: 'Delete profile',
        },
      },
    },
    creator: {
      title: 'Create new profile',
      save: 'Create profile',
    },
  },

  labels: {
    noneAssigned: 'None assigned',
    missing: 'Missing',
    duration: 'Duration',
    search: 'Search',
    minutes: '1 minute |||| %{smart_count} minutes',
    minutesShort: '1 min |||| %{smart_count} min',
  },

  episode: {
    singular: 'Episode',
    plural: 'Episodes',
    fields: {
      title: 'Title',
      summary: 'Summary',
      content: 'Content',
      languageIds: 'Languages',
      tags: 'Tags',
      contributorIds: 'Contributors',
      timeslotIds: 'Broadcast dates',
      mediaDescription: 'Media description',
    },
    labels: {
      changingPastMedia:
        'This episode has already been broadcast. Please be careful when changing its media sources.',
      assign: 'Assign other episode',
      noneAssigned: 'No episodes have been assigned yet.',
      noneFound: 'No episodes were found.',
      noTitle: '(no title set)',
      createNew: 'Create new episode',
      perPage: 'Episodes per page',
      onDate: 'Episode on %{date}',
      numbered: 'Episode #%{number}',
      noAdditionalBroadcasts: 'No additional broadcasts planned',
      additionalBroadcasts: 'Additional broadcasts',
      searchPlaceholder: 'e.g. episode content like the title',
      withoutTimeslots: 'No scheduled broadcasts',
      beforeDate: 'Before the',
      markAsRepetition: 'Mark repetition',
    },
    deletion: {
      title: 'Delete episode',
      description: 'Are you sure you want to delete this episode?',
      confirmLabel: 'Yes, delete episode',
    },
    assignment: {
      clear: 'Clear assignment',
      clearDescription:
        'Clear the assignment if you prefer to play the episode on a different broadcast date. The content of the episode will not be deleted.',
      searchExisting: 'Search existing episodes',
    },
  },

  timeslot: {
    singular: 'Broadcast date',
    plural: 'Broadcast dates',
    count: 'one broadcast date |||| %{smart_count} broadcast dates',
    fields: {
      start: 'Start',
    },
    labels: {
      noneAssigned: 'No broadcast dates have been assigned yet.',
      noneFound: 'No broadcast dates were found.',
      since: 'From',
      inFuture: 'Future',
      inPast: 'Past',
      perPage: 'Dates per page',
      duration: 'Length',
      loading: 'Broadcast dates are being loaded',
      isRepetition: 'This broadcast is a repetition of a previous episode.',
      broadcastTime: 'Time of broadcast',
      showActions: 'Open actions',
      showInWeekCalendar: 'Show in week calendar',
      mediaSources: 'Broadcast media sources',
      originallyPlannedOn: 'Originally on %{date}',
      editTime: 'Edit broadcast time',
      inheritedMedia: 'Current media sources',
      repetitionOf: 'Repeat broadcast from %{date}',
      initialBroadcastOn: 'First broadcast on %{date}',
    },
    flows: {
      assignEpisode: {
        title: 'Assign Episode',
        action: 'Assign',
      },
      assignEpisodeByCBA: {
        title: 'Mark current broadcast as repetition',
        message:
          'Would you like to mark the current broadcast as a repetition of the following episode?',
        action: 'Mark as repetition',
      },
      delete: {
        title: 'Delete broadcast',
        action: 'Delete broadcast',
        message: 'Are you sure you want to delete this broadcast?',
        changingPast:
          'This broadcast is in the past or has already begun. Double-check if it really should be deleted.',
      },
      move: {
        title: 'Broadcast time',
        action: 'Save new broadcast time',
        newStart: 'New start time',
        newEnd: 'New end time',
        duration: 'Duration',
        changeDuration: 'Change duration',
        changingPast:
          'The information you’ve entered change the past or current program. Please ensure that they are correct.',
        conflictResolution: {
          title: 'Conflicts with other broadcast dates',
          message: 'Rescheduling the broadcast results in conflicts.',
          deleteConflicts: 'Delete conflicts',
        },
        errors: {
          mustBeInFuture: 'The date must be in the future.',
          hasConflicts:
            'Another broadcast is scheduled at this time. You can still go ahead and fix the conflicts.',
          cannotSolveConflicts: 'There is no solution for the conflicts.',
        },
      },
    },
  },

  media: {
    singular: 'media',
    plural: 'media',

    duration: 'Length',
    editor: {
      title: 'Media sources',
      isSaving: 'Media sources are being saved',
      editMediaSource: 'Edit media sources',
      deleteMediaSource: 'Delete media source',
      noEntries: 'No media sources have been assigned.',
      entriesAdd: {
        retry: 'Try again',
        discard: 'Discard',
        error: 'Some of the media sources could not be added.',
      },
      upload: {
        pending: 'New sources',
        step: {
          fetching: 'Importing',
          normalizing: 'Normalizing',
          unknown: 'Processing',
        },
      },
      uploadFiles: {
        discarded:
          '<p>Some files were discarded because they were not recognized as audio files. This includes:</p>%{discardedFileList}',
      },
      control: {
        _or: '- or -',
        dropFiles: 'Drag files on this area',
        selectFiles: 'Select local file',
        importFile: 'Import file from URL',
        addStream: 'Add stream',
        addInput: 'Add input',
        addM3u: 'Add M3U',
        addPool: 'Add pool',
      },
      fileDialog: {
        editTitle: 'Edit file source',
        saveLabel: 'Save file',
      },
      fileImportDialog: {
        addTitle: 'Import file from URL',
        saveLabel: 'Import file',
      },
      inputDialog: {
        addTitle: 'Add input as media source',
        editTitle: 'Edit input media source',
        saveLabel: 'Save input',
      },
      streamDialog: {
        addTitle: 'Add stream as media source',
        editTitle: 'Edit stream media source',
        saveLabel: 'Save stream',
      },
      m3uDialog: {
        addTitle: 'Add M3U as media source',
        editTitle: 'Edit M3U media source',
        saveLabel: 'Save M3U',
      },
      poolDialog: {
        addTitle: 'Add pool as media source',
        editTitle: 'Edit pool media source',
        saveLabel: 'Save pool',
      },
    },
    labels: {
      variableDuration: 'Dynamic length',
      loading: 'Media are being loaded',
    },
    inheritance: {
      schedule: 'inherited from schedule',
      show: 'inherited from show',
    },
    state: {
      invalid: {
        tooShort: {
          title: 'There is airtime left',
          shortLabel: 'Too short',
          description: `The media sources are <strong>%{offset}</strong> shorter than the broadcast. Your episode will be played. The remaining broadcast time will be filled with a random selection of music. If you don't want that, add more media sources.`,
        },
        tooLong: {
          title: 'The airtime is exceeded',
          shortLabel: 'Too long',
          description: `The media sources are <strong>%{offset}</strong> longer than the broadcast. Your episode will be played, but it cuts off at the end (with a fade-out). If you want episode to play in its entirety, please shorten it.`,
        },
        multipleUnknownDurations: {
          title: 'Media sources with invalid length',
          shortLabel: 'Invalid media sources',
          description:
            'There may be a maximum of one media source without a length. Please set a length for the relevant media sources.',
        },
        missing: {
          title: 'No media sources',
          shortLabel: 'No media sources',
          description: 'There are no media sources for radio playout.',
        },
      },
    },
  },

  mediaSource: {
    singular: 'Media source',
    plural: 'media sources',
    count: '%{smart_count} media source |||| %{smart_count} media sources',
    fields: {
      source: 'Source',
    },
    labels: {
      noneAssigned: 'No media sources have been assigned yet.',
      autoDuration: 'Automatically calculated length',
      playerPreview: 'Media preview',
    },
    type: {
      file: 'Upload',
      stream: 'Stream',
      m3u: 'M3U',
      line: 'Input',
      pool: 'Pool',
      unknown: 'Unknown',
    },
  },

  recording: {
    singular: 'Recording',
    plural: 'Recordings',
    labels: {
      from: 'Recording from',
      noneAvailable: 'There is no recording available yet.',
      needsReview:
        'There are issues with the recording (breaks, fallbacks, etc). Please review the recording before using it elsewhere.',
    },
    flows: {
      delete: {
        title: 'Delete Recording',
        action: 'Delete Recording',
        message:
          'Are you sure you want to delete this recording? It will be automatically restored if necessary, such as for reruns.',
      },
    },
  },

  category: {
    singular: 'Category',
    plural: 'Categories',
  },

  program: {
    singular: 'Program',
    labels: {
      actions: 'Actions',
    },
    filter: {
      open: 'Open display options',
      sections: {
        filter: {
          title: 'Display',
          values: {
            none: 'Everything',
            own: 'My shows',
            free: 'Free slots',
            invalidMedia: 'Invalid media sources',
            emptyEpisode: 'Empty episode',
          },
        },
      },
    },
    flows: {
      prolong: {
        title: 'Automatic program prolongation',
        startEnableLabel: 'Set start for prolongation',
        startLabel: 'Prolong from',
        untilLabel: 'Prolong until',
        action: 'Prolong program until %{until}',
        description:
          'The program prolongation is performed in the background. It may therefore take a while for the process to complete.',
      },
    },
  },

  show: {
    singular: 'Show',
    plural: 'Shows',
    fields: {
      categoryIds: 'Categories',
      cbaSeriesId: 'CBA ID',
      description: 'Description',
      email: 'Email',
      fundingCategoryId: 'Funding category',
      hostIds: 'Editorial team',
      id: 'ID',
      imageId: 'Image',
      internalNote: 'Internal note',
      involvedPeopleCount: 'Number of people involved',
      storageQuota: 'Storage Quota (MiB)',
      usedMediaQuota: 'Used Storage Quota',
      isActive: 'Active',
      isPublic: 'Publicly visible',
      isOwner: 'Administrated by me',
      languageIds: 'Languages',
      links: 'Links',
      logoId: 'Logo',
      musicFocusIds: 'Music genres',
      name: 'Title',
      ownerIds: 'Administrators',
      predecessorId: 'Predecessor',
      shortDescription: 'Subtitle / short description',
      slug: 'Slug',
      topicIds: 'Topics',
      typeId: 'Type',
      updatedAt: 'Last modification',
      updatedBy: 'Modified by',
    },
    labels: {
      loading: 'Loading shows',
      onAir: 'On air',
      onAirSince: 'Since %{from}.',
      onAirBetween: 'From %{from} until %{to}.',
      onAirNone: 'Was not on air until now.',
    },
    flags: {
      private: {
        label: 'Not public',
        description: 'This show is not publicly visible.',
      },
      stationFallback: {
        label: 'Fallback program',
        description:
          'The program of this show is played if no other program is scheduled for the timeframe.',
      },
    },
    slugDetail: {
      title: 'Slug',
      editRemark:
        'The show slug can be modified in the <a href="#%{dangerZoneId}">%{dangerZone}</a>.',
    },
    housekeeping: {
      flows: {
        archival: 'Archiving',
        deletion: 'Deletion',
        slugRenaming: 'Renaming the URL slug',
      },
    },
    section: {
      basic: { title: 'Basic information' },
      content: { title: 'Content information' },
      contact: { title: 'Editors & Contact' },
      administrative: { title: 'Administration' },
      media: { title: 'Default media sources' },
    },
    editor: {
      deactivation: {
        label: 'Deactivate show',
        description: 'Archives the show and removes all planned broadcasts.',
        confirm: {
          text:
            'All future <strong>broadcasts</strong> and related information <strong>will be removed</strong>. ' +
            'Are you sure you want to deactivate <strong>%{show}</strong>?',
          prompt: 'Please enter <code>%{challenge}</code> in order to confirm.',
          confirmLabel: 'Deactivate show',
        },
      },
      activation: {
        label: 'Activate show',
        description: 'Dearchives the show. New broadcast schedules must be created.',
      },
      deletion: {
        label: 'Delete show',
        description:
          'Removes the show and all related information including schedules and broadcasts.',
        confirm: {
          text: 'All information on this series will be <strong>irretrievably deleted</strong>. It is not possible to restore it later. Are you sure you want to delete <strong>%{show}</strong>?',
          prompt: 'Please enter <code>%{challenge}</code> in order to confirm.',
          confirmLabel: 'Delete show',
        },
      },
      slugRenaming: {
        dialogTitle: 'Renaming the URL slug',
        label: 'Rename',
        description:
          'Renames the URL slug of the show. The slug is likely used in website links. A change may invalidate existing links to the show and should be carefully considered.',
        confirm: {
          text: 'The URL slug will be renamed. Existing web links to this show will possibly be invalidated. Are you sure you want to rename the slug for <strong>%{show}</strong>?',
          prompt: 'Please enter <code>%{challenge}</code> in order to confirm.',
          confirmLabel: 'Rename show URL slug',
        },
      },
    },
  },

  showFilter: {
    order: {
      choices: {
        id: { name: 'ID', directions: { asc: '0 - 9', desc: '9 - 0' } },
        name: { name: 'Name', directions: { asc: 'A - Z', desc: 'Z - A' } },
        is_active: { name: 'Active', directions: { asc: 'Active last', desc: 'Active first' } },
        is_owner: {
          name: 'Administrated by me',
          directions: { asc: 'Mine last', desc: 'Mine first' },
        },
        updated_at: {
          name: 'Last modification',
          directions: { asc: 'Oldest first', desc: 'Newest first' },
        },
        updated_by: { name: 'Modified by', directions: { asc: 'A - Z', desc: 'Z - A' } },
      },
    },
  },

  credits: {
    title: 'Credits',
    intro: 'AURA is developed under the GNU Affero General Public License v3.',
    contributors: 'Contributors',
    contributorLabel: 'Current and former developers are:',
    moreInfo:
      'For more infos visit the <a href="https://gitlab.servus.at/aura/dashboard">Dashboard repository</a>.<br>To get started with AURA, visit <a href="https://aura.radio">aura.radio</a>.<br>All AURA repositories can be found at <a href="https://code.aura.radio">https://code.aura.radio</a>.',
  },

  generalDocumentation: 'Help & Documentation',

  // Layout
  loadMoreItems: 'Load more %{items}',
  loadingData: 'Loading %{items}',
  loading: 'Loading..',
  cancel: 'Cancel',
  dismiss: 'Dismiss',
  download: 'Download',
  back: 'Back',
  moreOptions: 'More options',
  yes: 'Yes',
  no: 'No',
  auto: 'Automatic',
  active: 'Active',
  inactive: 'Inactive',
  help: 'Help',
  delete: 'Delete',
  unassign: 'Deselect',
  unassignItem: 'Deselect %{item}',
  new: 'New',
  add: 'Add',
  save: 'Save',
  goBack: 'Go back to previous page',
  ok: 'OK',
  browse: 'Browse',
  drop: 'Drop file here',
  edit: 'Edit',
  move: 'Move',
  language: 'Language',
  slug: 'Slug',
  dangerZone: 'Danger zone',
  unimplemented:
    'By the mighty witchcraftry of the mother of time!\n\nThis feature is not implemented yet.',
  noneSetMasculine: '(none set)',
  noneSetFeminine: '(none set)',
  noneSetNeuter: '(none set)',
  noAssignedShows:
    'You have not been assigned any shows yet.<br>They can be assigned in the <a href="%{adminUrl}">administration interface</a>.',
  by: 'by',
  actionRequired: 'Action required',

  auth: {
    signOut: 'Sign out',
    signIn: 'Sign in',
    permissionError: 'You are not permitted to view this page',
  },

  drag: {
    up: 'Move up',
    down: 'Move down',
    move: 'Move',
  },

  construction: {
    label: 'Construction Site',
  },

  topNavigation: {
    title: 'Top navigation',
  },

  navigation: {
    _title: 'Main navigation',
    _open: 'Open main navigation',
    _close: 'Close main navigation',
    _jumpToContent: 'Jump to content',
    home: 'Home',
    shows: 'Shows',
    show: {
      episodes: 'Episodes',
      timeslots: 'Broadcasts',
      schedules: 'Schedules',
      settings: 'Settings',
    },
    episode: {
      _title: 'Episode from %{start}',
      details: 'Description',
    },
    overviews: 'Overviews',
    program: 'Program',
    misc: 'Miscellaneous',
    profiles: 'Profiles',
    calendarWeek: 'Week calendar',
    calendarDay: 'Day calendar',
    programProlongation: 'Prolongation',
    programFallback: 'Fallback program',
    settings: 'Settings',
    profile: 'Profile',
    administration: 'Administration',
    myAccount: 'My Account',
    credits: 'Credits',
    help: 'Help',
  },

  breadcrubs: {
    _title: 'Breadcrumbs',
  },

  profileList: {
    title: 'Profiles',
    searchLabel: 'Search by name',
    searchPlaceholder: 'Name of the profile...',
  },

  profileDetails: {
    assignedAccounts: 'Assigned Accounts',
    data: 'Data',
  },

  myAccount: {
    data: 'My Account',
    profiles: 'My Profiles',
    aboutMe: 'About me',
    settings: 'Settings',
  },

  settings: {
    language: { label: 'Language', description: 'This setting is saved in your browser.' },
    darkMode: {
      label: 'Dark Mode',
      description:
        'Displays the page in dark shades. The dark mode is still in an experimental state. Some components are not yet adapted, others still need some fine-tuning.',
    },
  },

  userMenu: {
    myAccount: 'My Account',
    logout: 'Sign out',
  },

  footer: {
    navigationTitle: 'Help & More',
    tagline: 'All the UI you need to run a community radio',
  },

  // Specific components
  header: {
    showMoreDesktop: 'Hit menu button for more',
    showMoreMobile: 'For more options tap the menu button on the right',
  },

  input: {
    singular: 'Input',
    unknown: 'Unknown Input',
  },

  pool: {
    name: 'Directory',
  },

  file: {
    singular: 'File',
    url: 'URL',
    name: 'Filename',
    unnamed: 'Unnamed file',
    duration: 'Length',
    durationUnknown: 'Dynamic length',
    durationPlaceholder: 'e.g. 2m6s',
    uploadProgress: 'Progress of the file upload',
    uploadError: 'Error during upload',
    retryUpload: 'Retry upload',
    metadata: {
      _title: 'Metadata',
      album: 'Album',
      artist: 'Artist',
      title: 'Title',
      fromAlbum: '<em>%{title}</em> from the album <em>%{album}</em>.',
      byArtist: '<em>%{title}</em> by <em>%{artist}</em>.',
      byArtistFromAlbum:
        '<em>%{title}</em> by <em>%{artist}</em> from their album <em>%{album}</em>.',
    },
    importLog: {
      title: 'File import log',
      showImportLog: 'Show import log',
      start: '# %{title} started at %{time}',
    },
  },

  mediaSourceJob: {
    showInfo: 'Show details',
    state: {
      label: {
        // internal operation
        queued: 'Queued',
        processing: 'Processing',
        resolvingMedia: 'Resolving media',
        creatingBatteryPipeline: 'Creating pipeline',
        // battery
        upload: 'Uploading',
        resolvingCBA: 'Checking CBA',
        importingFile: 'Importing',
        checkingData: 'Checking data',
        extractingAudio: 'Extracting audio',
        extractingMetadata: 'Extracting metadata',
        normalizingFile: 'Normalizing',
        convertingFile: 'Converting',
        generatingMetadata: 'Generating metadata',
        storeInFilesystem: 'Storing file',
        storeInDatabase: 'Storing data',
        syncing: 'Synchronizing',
      },
      failures: {
        failed: 'An error occurred while processing this media source. This may be temporary.',
        cancelled: 'You have aborted the import job. You may retry if this was an error.',
        rejected: 'The media source could not be processed.',
        notAnAudioFile: 'The selected file is not an audio file.',
        uploadFailed: 'The file upload failed.',
        unableToCreateMediaSource: 'Could not create media source.',
        unableToResolveMedia: 'Could not resolve media.',
        unableToCreatePipeline: 'Could not create import pipeline.',
      },
    },
  },

  mediaTable: {
    // Our translation framework automatically picks singular/plural
    items: '%{smart_count} item |||| %{smart_count} items',
    assign: 'Assign',
    unset: 'Unset',

    index: 'Nr',
    description: 'Description',
    entries: 'Entries',
    duration: 'Length',
    lastEdit: 'Last edited',
    type: 'Type',
    source: 'Source',
    actions: 'Actions',
  },

  linkType: {
    inactive: 'Obsolete',
  },

  link: {
    urlExample: 'i.e. https://aura.radio',
    noneSet: 'No links have been assigned.',
    fields: {
      typeId: 'Link type',
      url: 'Web Address',
    },
  },

  showSelector: {
    keyboardShortcut: 'Alt + K',
    selectShowMany: 'Select show:',
    selectShow: 'Select a radio show',
    noData: 'No shows have been created yet.',
    noDataMatch: 'There are no shows that match your search criteria.',
    showState: {
      label: 'Show status',
      active: 'Active',
      inactive: 'Inactive',
    },
  },

  showSchedules: {
    title: 'Schedules',
    times: 'Airtime',
    rhythm: 'Rhythm',
    firstBroadcast: 'Start date',
    lastBroadcast: 'End date',
    noSchedulesAvailable: 'There are no broadcast schedules available for the current selection.',
    showAll: 'Show All',
    hide: 'Hide',
    scheduleDescription:
      '%{rhythm} beginning %{startDate} from %{startTime} to %{endTime} respectively.',
    scheduleDescriptionFinite:
      '%{rhythm} beginning %{startDate} through %{endDate} from %{startTime} to %{endTime} respectively.',
    selection: {
      all: 'All',
      relevant: 'Current',
    },
  },

  languageSelector: {
    label: 'Choose a language',
  },

  user: {
    fields: {
      username: 'Username',
      firstName: 'Forename',
      lastName: 'Surname',
      name: 'Name',
      email: 'Email',
      profile: {
        cbaUsername: 'Username',
        cbaUserToken: 'Token',
      },
    },
    labels: {
      noProfilesAssigned: 'No profiles found that are assigned to your account.',
    },
  },

  noteEditor: {
    _title: 'Episode description',
    title: 'Title',
    titlePlaceholder: 'Enter a title',
    summary: 'Summary',
    summaryPlaceholder: 'Enter a summary',
    content: 'Content',
    contentPlaceholder: 'Describe the content of the show',
    image: 'Image',
    tags: 'Tags',
    contributors: 'Contributors',
    languages: 'Languages',
    topics: 'Topics',
    links: 'Platform & Social Media Links',
    cbaId: 'CBA Id',
  },

  error: {
    server: {
      'multiple-null-duration-media-sources':
        'There must not be more than one media source without a defined length. Please set a length for the existing media sources.',
      'no-fallback-show-defined':
        'No fallback show has been defined in the radio settings. This must be set for the calendar to be displayed correctly.',
      'no-start-after-end': 'The start date must be before the end date.',
      'no-same-day-start-and-end': 'The start date and end date must not fall on the same day.',
      'first-date-does-not-correspond-to-rrule-by-weekdays':
        'The first day of the schedule cannot be reconciled with the specified recurrence rule.',
      incorrect_type:
        'The server expected a different value. Please report this error to the development team.',
      does_not_exist: 'The entry does not exist.',
      unknown: 'An unknown error occurred.',
      exception: 'An unknown server error occurred.',
      permission_denied: 'You have insufficient permissions.',
      required: 'This field is required.',
      invalid: 'This field value is invalid.',
      max_length: 'The field value is too long.',
      min_length: 'The field value is too short.',
      null: 'This field cannot be empty.',
      blank: 'This field cannot be empty.',
      unique: 'The value of this field must be unique.',
      connection:
        'The server cannot be reached. ' +
        'This may be caused by a temporary issue with your internet connection or a problem with the server.',
      login: 'Login failed because of an unknown reason. Please contact your administrator.',
      failed_integrity_checks:
        'The server has detected an error in data processing. Please contact your administrator.',
      recording_not_available: 'The episode recording will not be available at the selected time.',
      no_recording: 'No recording is available (yet).',
      invalid_file_id: 'The selected file is not part of the episode.',
      unknown_file_id: 'The selected file does not exist.',
      upload_rejected_by_cba: 'The CBA has rejected the upload.',
      existing_cba_relation:
        'This CBA ID is already assigned to another episode. Please check if you have a typo in your CBA ID or if you are planning a repetition of the previous episode broadcast with this CBA ID.',
      unauthenticated: 'Credentials are missing or invalid.',
      missing_mapping:
        'There is a missing assignment in the backend. Please contact your administrator.',
    },
    oidc: {
      crypto_unavailable_browser:
        'Your browser is too old and does not support an important cryptographic function. You won’t be able to log in.',
      crypto_unavailable_origin:
        'The current environment of the Dashboard prevents the use of an important cryptographic function. Please use HTTPS or configure this origin as secure in your browser settings. You will not be able to log in.',
      invalid_request:
        'The server does not support the login method. Please let your administrator check if the authorization code flow is activated for the dashboard OIDC client.',
    },
  },

  imagePicker: {
    title: 'Pick an Image',
    browseImages: 'Browse Images',
    editCurrentImage: 'Edit the current image',
    saveChanges: 'Save changes',
    useImage: 'Use this image',
    chooseAnImage: 'Choose image',
    uploadImage: 'Upload new image',
    abort: 'Abort',
    reset: 'Remove Image',
    error: {
      default: 'Could not upload image.',
      tooLarge: 'The image you’ve selected is too large in filesize.',
    },
    liability: {
      title: 'Legal',
      confirm: 'I have clarified the rights/ license to publish this picture.',
    },
  },

  player: {
    labels: {
      progress: 'Playback progress',
      error: 'Error while loading or playing.',
      playFile: 'Play %{name}',
      pauseFile: 'Pause %{name}',
      play: 'Play',
      pause: 'Pause',
    },
  },

  licensing: {
    singular: 'Licensing',
    fields: {
      license: 'License',
      credits: 'Author',
      isUseExplicitlyGrantedByAuthor: 'Use was explicitly granted by author',
    },
  },

  imageManipulation: {
    processingImage: 'The image is being loaded',
    rotateLeft: 'Rotate the image 90° counterclockwise-',
    rotateRight: 'Rotate the image 90° clockwise.',
    flipHorizontal: 'Flip the image around its vertical axis',
    flipVertical: 'Flip the image around its horizontal axis',
    crop: 'Crop the image to the selection area.',
    cropActivate: 'Activate the crop mode.',
    cropUnfinishedError: 'Press the button to confirm the current crop selection.',
    aspectRatioError:
      'The image was not cropped to the required aspect ratio. Press the button to confirm the current crop selection.',
  },

  image: {
    altText: 'Alternative Text (for screen readers)',
  },

  license: {
    moreAbout: 'More about this license...',
    helpMeChoose: 'Help me choose a license…',
    validation: {
      requiresExpressPermissionForPublication:
        'The license requires explicit consent for publication on the part of the author.',
      requiresCredits:
        'The license requires attribution of the author. Please indicate their name.',
    },
  },

  saveIndicator: {
    label: {
      pending: 'Saving',
      success: 'Saved successfully',
      failure: 'Error on save',
    },
  },

  showCreator: {
    title: 'Create new show',
    missingShowTypes:
      'No show types have been created yet. You can add them in the <a href="%{adminUrl}/program/type/add/" target="_blank">administration interface</a>.',
    missingShowFundingCategories:
      'No funding categories have been created yet. You can add them in the <a href="%{adminUrl}/program/fundingcategory/add/" target="_blank">administration interface</a>.',
  },

  conflictResolution: {
    title: 'Conflict resolution for new schedule',

    conflictingSlot: 'New Timeslot',
    projectedSlot:
      'The new broadcast on <b class="tw-font-medium">%{firstDate}</b> from <b class="tw-font-medium">%{startTime}</b> to <b class="tw-font-medium">%{endTime}</b> conflicts with a broadcast from the following schedule:',

    alreadyResolved:
      'You have already resolved a conflict. |||| You have already resolved %{smart_count} conflicts.',
    leftToResolve: 'One conflict left to resolve |||| %{smart_count} conflicts left to resolve',
    noneLeftToResolve: 'You have resolved all conflicts!',
    applySolution: 'Apply conflict solutions',
    conflictOf: 'Conflict %{number} of %{total}',

    gotoPrevious: 'Go to previous conflict',
    gotoNext: 'Go to next conflict',
    gotoNextUnresolved: 'Next unresolved conflict',

    abort: 'Are you sure you want to abort the conflict resolution?',
    abortConfirm: 'Yes, abort conflict resolution',
    abortCancel: 'No, continue',
    abortTitle: 'Abort conflict resolution',

    applySolutionForSchedule: 'Apply this conflict’s solution to all conflicts of this schedule',
    appliedSolutionForSchedule:
      'This conflict’s solution is applied to all conflicts of this schedule',

    whichStrategy: 'How should the conflict be resolved?',
    strategies: {
      theirs: {
        label: 'Delete the new broadcast and keep existing one(s)',
        description: '',
      },
      'theirs-start': {
        label: 'Cut the new broadcast and insert <b>after</b> the existing broadcast',
        description: '',
      },
      'theirs-end': {
        label: 'Cut the new broadcast and insert <b>before</b> the existing broadcast',
        description: '',
      },
      'theirs-both': {
        label: 'Split the new broadcast and insert the existing one in between',
        description:
          'The new broadcast is divided into two parts. The first part ends with the start time and the second part starts with the end time of the existing broadcast.',
      },
      ours: {
        label: 'Keep the new broadcast and delete existing one(s)',
        description: '',
      },
      'ours-start': {
        label: 'Cut the existing broadcast and insert <b>before</b> the new broadcast',
        description: '',
      },
      'ours-end': {
        label: 'Cut the existing broadcast and insert <b>after</b> the new broadcast',
        description: '',
      },
      'ours-both': {
        label: 'Split the existing broadcast and insert the new one in between',
        description:
          'The existing broadcast is divided into two parts. The first part ends with the start time and the second part starts with the end time of the new broadcast.',
      },
    },
  },

  paginator: {
    itemsPerPage: 'Items per Page',
    gotoFirst: 'Go to first page',
    gotoPrev: 'Go to previous page',
    goto: 'Go to page %{page}',
    gotoNext: 'Go to next page',
    gotoLast: 'Go to last page',
    range: 'Showing %{start} to %{end} of %{count} entries.',
  },

  schedule: {
    singular: 'Schedule',
    plural: 'Schedules',
    fields: {
      firstDate: 'First date',
      lastDate: 'Last date',
    },
    labels: {
      openEnded: 'open ended',
      details: 'Details',
      showActions: 'Open actions',
      createRepetition: 'Create repetition schedule',
      schedulesWithFailedProlongation: 'Schedules that failed automatic prolongation',
      repetitionOf: 'Repetition schedule of',
      repetitionStartsWith: 'Starting point for repetition schedule',
      repetitionStartsWithFirst: 'First broadcast',
      repetitionStartsWithMostRecent: 'Most recent broadcast',
      repetitionStartsWithSelection: 'Selection',
      repetitionSchedule: 'Repetition schedule',
      repetitionSchedules: 'Repetition schedules',
      repetitionDurationNonModifiable:
        'The duration of the repetition schedule is based on the original schedule and cannot be changed.',
      description: {
        default: '%{rrule} %{start} ‑ %{end}',
        noEndTime: `%{rrule} %{start}`,
      },
    },
    flows: {
      end: {
        title: 'End schedule',
        action: 'End schedule after this broadcast',
        actionShort: 'End after this broadcast',
        confirm: 'End schedule on %{date}',
        message:
          '<p>Are you sure you want to end the schedule on %{date}?</p><p>Broadcasts after this date will be irrevocably deleted.</p>',
      },
      delete: {
        title: 'Delete schedule',
        description: 'Deletes the schedule including all past and future broadcast dates.',
        action: 'Delete schedule',
        confirm: {
          text: 'The schedule is deleted including all past and future broadcast dates. This affects <strong>%{count}</strong>. Content in the form of episodes is retained. This action cannot be undone. Are you sure you want to continue?',
          prompt: 'Please enter <code>%{challenge}</code> as confirmation.',
          confirmLabel: 'Delete schedule incl. %{count}',
        },
      },
      shortenOrExtend: {
        title: 'Extend / shorten schedule',
        shorten: 'End schedule on %{date}',
        extend: 'Extend schedule until %{date}',
        extendIndefinite: 'Extend schedule permanently',
        lastBroadcast: 'Last broadcast',
        loadingLastBroadcast: 'Loading last broadcast',
        conflictResolverTitle: 'Conflicts for extended schedule',
      },
      prolong: {
        title: 'Manual schedule prolongation',
        action: 'Resolve issue',
        prolongManually: 'Prolong manually',
        ignore: 'Ignore',
        message:
          '<p>This schedule could not be automatically prolonged.</p><p>You can prolong the schedule manually and resolve any conflicts yourself. Alternatively, you can ignore the problem. In this case the schedule will not be prolonged.</p>',
      },
    },
  },

  scheduleEditor: {
    titleCreate: 'Create new schedule for %{show}',
    titleEdit: 'Edit schedule for "%{show}"',
    shortInfo: 'About this broadcast',
    followingEpisodes: 'Following broadcasts',

    timeslotRuns:
      'This broadcast runs on <b>%{firstDate}</b> from <b>%{startTime}</b> to <b>%{endTime}</b>',
    recurringSchedule: 'This schedule repeats from <b>%{rrule}</b> to <b>%{lastDate}</b>',

    singleEmission: 'This broadcast is played only once.',
    coexistingTimeslot: 'Due to a conflict resolution additional broadcast have been created.',

    addFallbackTitle: 'Add fallback for schedule',

    start: 'Start',
    end: 'End',
    duration: 'Duration',
    projectedEnd: 'Projected end: %{time}',

    pastEventError: 'Please set a start date in the future.',
    pastEventWarning: 'You are creating a schedule that starts in the past.',
    from: 'Start time',
    to: 'End time',
    fromDate: 'Start date',
    fromDateSingle: 'Date',
    toDate: 'End date',

    addRepetition: 'Add repetition schedule',
    whenToRepeat: 'When to repeat?',
    useSameTime: 'Use same start and end time',
    repeatAt: 'Repeat at',
    addNoOfDays: 'How many days later?',
    onlyBusinessDays: 'Only count business days',
    create: 'Create new schedule',
    createConfirmTitle: 'New schedule',
    createConfirmMessage: 'Should the new schedule be created now?',
    createConfirmAction: 'Yes, create schedule',
    noFutureEpisodes: 'There are no subsequent broadcasts planned.',
    delete: {
      schedule: 'Delete schedule and all broadcasts',
      timeslot: 'Delete only this broadcast',
    },
  },

  repetition: {
    nextDay: 'On the following day',
    nextBusinessDay: 'On the following business day',
    nDaysLater: 'A number of days later',
  },

  fallbackSlot: {
    fields: {
      startTime: 'Start time',
      endTime: 'End time',
    },
    editor: {
      addTitle: 'Add fallback program entry',
      editTitle: 'Edit fallback program entry',
      add: 'Add entry',
      close: 'Close',
    },
  },

  editingMetadata: {
    timeSpecific: 'on %{date}',
    lastModified: 'Last modified %{time} by %{author}.',
    created: 'Created %{time} by %{author}.',
  },

  calendar: {
    minutesPerRow: 'Resolution',
    today: 'Today',
    date: 'Date',
    nextDay: 'Next day',
    prevDay: 'Previous day',
    week: 'Calendar week',
    currentWeek: 'This week',
    prevWeek: 'Previous week',
    nextWeek: 'Next week',
    empty: 'No media',
    fallback: 'Fallback media',
    repetition: 'Repetition',
    showInWeekCalendar: 'In week calendar',
    view: {
      day: 'Day view',
      week: 'Week view',
    },
    switchShow: 'Switch to “%{show}” show',
    editTimeslot: 'Edit broadcast',
    intermission: 'Program intermission',
    mismatchedLength: 'wrong duration',
    playing: 'Currently playing',
  },

  playoutMode: {
    _title: 'Playout mode',
    linear: 'Linear',
    random: 'Random',
  },

  // Etc
  metadata: {
    artist: 'Artist',
    album: 'Album',
    title: 'Title',
    source: 'Source',
    size: 'File size',
  },

  humanJoin: {
    default: ', ',
    and: ', and ',
    or: ', or ',
  },

  rrule: {
    rrule: 'Repetition rule',
    unknown:
      'Unable to create an automated description of the repetition rule. Please file an issue for the aura/dashboard project.',
    once: 'once',
    daily: 'every day |||| every %{smart_count} days',
    weekly: 'every week |||| every %{smart_count} weeks',
    monthly: 'every month |||| every %{smart_count} months',
    yearly: 'every year |||| every %{smart_count} years',
    businessDay: 'business day |||| business days',
    onDays: 'on %{days}',
    position: {
      '-1': 'on the last',
      1: 'on the first',
      2: 'on the second',
      3: 'on the third',
      4: 'on the fourth',
      5: 'on the fifth',
    },
  },

  steeringErrorCodes: {
    'no-start-after-end': 'The start date cannot be after the end date.',
    'no-same-day-start-and-end': 'The start and end date cannot be on the same day.',
    'one-solution-per-conflict':
      'Exactly one solution is required per conflict. You either submitted no or more than one solution.',
  },

  cba: {
    title: 'CBA',
    labels: {
      loading: 'Loading CBA data',
      duplicateEpisode: 'Existing episode',
    },
  },

  cbaPublicationStatus: {
    unlisted: 'Not listed',
    private: 'Private',
    publish: 'Published',
    future: 'In the future',
  },

  cbaCredentials: {
    fields: {
      username: 'Account name',
      password: 'App password',
    },
  },

  cbaEpisodeMapping: {
    fields: {
      cbaPostId: 'Post Id',
    },
    labels: {
      cbaPost: 'Post',
      hiddenCbaPost: '(Hidden post)',
      invalidPost: 'That does not appear to be a valid CBA post id.',
      removeMapping: 'Remove assignment',
      assignPost: 'Assign CBA post',
      assignManually: 'Assign',
      assignManuallyExt: 'Assign post',
      uploadFile: 'Upload',
    },
  },

  cbaShowConfiguration: {
    fields: {
      cbaSeriesId: 'CBA Id',
      enableAutoUploads: 'Automatic uploads',
      uploadUsername: 'Account name',
      uploadPassword: 'App password',
      publicationStatusDefault: 'Publication status',
      containsAkmMaterialDefault: 'Contains AKM content',
      licenseIdDefault: 'License',
      categoryIdDefault: 'CBA category',
    },
    labels: {
      defaultUploadSettings: 'Upload defaults',
      credentialSettings: 'Default credentials',
      activateAutoUploads: 'Activate',
      missingCredentials: 'Please provide default credentials for automatic uploads.',
    },
  },

  cbaUpload: {
    fields: {
      publicationStatus: 'Publication status',
      containsAkmMaterial: 'Contains AKM content',
      licenseId: 'License',
      categoryId: 'CBA category',
      credentialsSource: 'Credentials',
    },
    credentialSource: {
      show: 'Show',
      user: 'Mine',
      any: 'Any',
    },
    labels: {
      upload: 'Upload',
      publishedAs: 'Published in the CBA as',
      uploadPreproductionTitle: 'Upload pre-production to the CBA',
      uploadPreproduction: 'Upload pre-production',
      uploadRecordingTitle: 'Upload recording to the CBA',
      uploadRecording: 'Upload recording',
      uploadFrom: 'Upload from %{date}',
      invalidEpisode: 'The episode contains invalid data.',
      chooseFile: 'Select a media source to be published as a pre-production in the CBA.',
      discardedFiles:
        'One file is not suited for the CBA. |||| %{smart_count} files are not suited for the CBA.',
    },
    taskState: {
      READY: 'Waiting for execution...',
      RUNNING: 'Uploading...',
      FAILED: 'Failed',
      SUCCESSFUL: 'Uploaded successfully',
    },
  },

  mediaResolution: {
    resolvedMedia: 'Resolved media',
    resolvers: {
      cba: {
        validatingUrl: 'CBA: Validating URL',
        fetchingMedia: 'CBA: Fetching media data',
        fetchingMetadata: 'CBA: Fetching metadata',
        processingMedia: 'CBA: Processing media data',
      },
    },
  },

  i18n: {
    translatable: 'This field can be translated.',
    translationLanguage: 'Translation language',
  },
}
